import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'privacy-policy',
    templateUrl: './privacy-policy.component.html',
    imports: [
        
    ]
})

export class PrivacyPolicyComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}